var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isBaseReport)?_c('v-btn',{staticClass:"text-none",attrs:{"small":"","color":"primary","loading":_vm.updating,"disabled":!_vm.saveEnabled},on:{"click":_vm.saveReport}},[_vm._v(" "+_vm._s(_vm.saveEnabled ? _vm.$t('save') : _vm.$t('saved'))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }